import type { UsersWithRelations } from "@ch/generated";
import storage from "localforage";
import { persistReducer } from "redux-persist";
import UserActionTypes from "./types";

export interface IAppUserState {
  accessToken?: string;
  refreshToken?: string;
  currentUser?: UsersWithRelations;
  isLoggedIn?: boolean;
  userType?: string;
  error?: string;
  fcmTokenUpdatedAt?: string;
  location?: {
    longitude?: number;
    latitude?: number;
  };
  locationFetchedAt?: string;
  locationPromptDismissedAt?: string;
}

export const INITIAL_USER_STATE = {
  error: "",
  isLoggedIn: false,
  accessToken: "",
  refreshToken: "",
  currentUser: undefined,
  userType: "",
  fcmTokenUpdatedAt: undefined,
  location: undefined,
  locationFetchedAt: undefined,
  locationPromptDismissedAt: undefined,
};

function userReducer(
  // Redux insists
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: IAppUserState = INITIAL_USER_STATE,
  { type, payload }: { type: UserActionTypes; payload: Partial<IAppUserState> },
) {
  switch (type) {
    case UserActionTypes.UPDATE_APP_USER_STATE:
      return {
        ...state,
        ...payload,
      };
    case UserActionTypes.LOGOUT:
      return INITIAL_USER_STATE;
    default:
      return state;
  }
}

const persistConfig = {
  key: "user",
  storage,
  blacklist: ["error", "isLoading", "loading"],
};

export default persistReducer(persistConfig, userReducer);
